<template>
  <el-tag :type="matching.type">
    {{matching.name}}
  </el-tag>
</template>

<script>
export default {
  props: {
    // 状态号
    // 0
    num: {
      type: [Number, String],
      required: true
    },
    // 状态配置项
    // {
    //   0:{name:'下架',type:'info'},
    //   1:{name:'上架',type:'primary'},
    // }
    opt: {
      type: Object,
      required: true
    }
  },
  computed: {
    matching () {
      return this.opt[this.num] || {}
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
